import React from 'react'
import { logo } from 'images'
import { MEDIA_QUERY } from 'styles'
import { css } from 'emotion'

const LogoView = ({ className }) => (
  <img className={css(styles.logo, className)} src={logo} alt="Ebisu" />
)

const styles = {
  logo: css({
    cursor: 'pointer',
    height: '8.5rem',
    objectFit: 'contain',
    transition: 'all .2s',
    '&:hover': {
      transform: 'scale(1.03)',
    },
    [MEDIA_QUERY.SM]: {
      height: '6rem',
    },
  }),
}

export default LogoView
